import { api } from './api';

export type AssignmentOp = 'eq' | 'contains' | 'starts_with' | 'in';
export type AssignmentField =
  | 'country_code'
  | 'industry'
  | 'employee_band'
  | 'jp_corp_number'
  | 'domain';

export interface AssignmentCondition {
  field: AssignmentField;
  op: AssignmentOp;
  value: string | string[];
}

export interface AssignmentRule {
  id: string;
  workspaceId: string;
  name: string;
  conditions: AssignmentCondition[];
  assignToUserId: string | null;
  roundRobinPool: string[];
  priority: number;
  enabled: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateAssignmentRuleInput {
  name: string;
  conditions: AssignmentCondition[];
  assignToUserId?: string;
  roundRobinPool?: string[];
  priority?: number;
  enabled?: boolean;
}

export interface UpdateAssignmentRuleInput {
  name?: string;
  conditions?: AssignmentCondition[];
  assignToUserId?: string | null;
  roundRobinPool?: string[];
  priority?: number;
  enabled?: boolean;
}

export const assignmentApi = {
  async list(wsId: string): Promise<AssignmentRule[]> {
    const r = await api.get<AssignmentRule[]>(
      `/api/workspaces/${wsId}/assignment-rules`,
    );
    return r.data;
  },
  async create(
    wsId: string,
    input: CreateAssignmentRuleInput,
  ): Promise<AssignmentRule> {
    const r = await api.post<AssignmentRule>(
      `/api/workspaces/${wsId}/assignment-rules`,
      input,
    );
    return r.data;
  },
  async update(
    wsId: string,
    id: string,
    patch: UpdateAssignmentRuleInput,
  ): Promise<AssignmentRule> {
    const r = await api.patch<AssignmentRule>(
      `/api/workspaces/${wsId}/assignment-rules/${id}`,
      patch,
    );
    return r.data;
  },
  async remove(wsId: string, id: string): Promise<void> {
    await api.delete(`/api/workspaces/${wsId}/assignment-rules/${id}`);
  },
  async applyAll(
    wsId: string,
  ): Promise<{ assigned: number; skipped: number }> {
    const r = await api.post<{ assigned: number; skipped: number }>(
      `/api/workspaces/${wsId}/assignment-rules/apply-all`,
      {},
    );
    return r.data;
  },
};
